/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

import legalPageStyle from "assets/jss/views/legalPage/legalPageStyle";
const useStyles = makeStyles(legalPageStyle);

import { sEmailContact } from "assets/jss/views/ResStrings";
import { getDoc, ApricotAction } from "client/actions/modal";
import { progressCircles } from "components/Form/FormField";

interface Props {
  getDoc: ApricotAction;
  docDisclaim: string;
  classes: any;
}

const DisclaimerBase: React.FC<Props> = ({ getDoc, docDisclaim }: Props) => {
  const classes = useStyles();

  useEffect(() => {
    docDisclaim === null && getDoc(3);
  }, []);

  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();

  return docDisclaim ? (
    <div className={classes.content}>
      {parser.parse(docDisclaim)}
      <p>
        {`If you have any other questions about this policy, please email ${sEmailContact}.`}
      </p>
      <p className={classes.ending}>&sect;</p>
    </div>
  ) : (
    progressCircles()
  );
};

function mapStateToProps(state: any) {
  return {
    docDisclaim: state.state_modal.docDisclaim,
  };
}

const base: any = DisclaimerBase;
export const Disclaimer = connect(mapStateToProps, { getDoc })(base);
